import { InMemoryCache } from '@apollo/client';
import { GET_RETURNING_USER_ROLES } from 'graphqls/profile';

export const initializeReturningUserRoles = (cache: InMemoryCache): void => {
  cache.writeQuery({
    query: GET_RETURNING_USER_ROLES,
    data: { returningUserRoles: [] },
  });
};

export default {
  resolvers: {
    Mutation: {
      setReturningUserRoles: (_, { returningUserRoles }, { cache }): null => {
        cache.writeQuery({
          query: GET_RETURNING_USER_ROLES,
          data: {
            __typename: 'returningUserRoles',
            returningUserRoles,
          },
        });

        return null;
      },
    },
  },
};
